import type { BaseThemePrepared, StyleRule } from '@archipro-design/aria';

import {
    productTileSlotClassNames,
    tileImageClassName,
} from '@archipro-design/aria';

export const ProfessionalLink: StyleRule = ({ theme }) => ({
    textDecorationColor: `${theme.siteVariables.bodyColor} !important`,
});

export const BoxToDisableClickOnTile: StyleRule = ({ theme }) => ({
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: theme.siteVariables.zIndexes.foreground,
    top: 0,
});

export const ProductTagImage = ({
    theme,
    approved,
}: {
    theme: BaseThemePrepared;
    approved: boolean;
}) => {
    if (approved) {
        return {};
    }

    return {
        border: `1px solid ${theme.siteVariables.colors.danger[200]}`,
    };
};

export const ProductTile: StyleRule = () => ({
    [`& > .${tileImageClassName}`]: {
        [`& + .${productTileSlotClassNames.content}`]: {
            padding: 0,
        },
    },
});
